// All the events

export const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
  CODE_CHANGE: "conde-change",
  SYNC_CODE: "sync-code",
  LEAVE: "leave",
  CURSOR_ACTIVITY: "cursor-activity",
  TEXT_HIGHLIGHT: "text-highlight",
  TYPING: "typing",
};
